import { render, staticRenderFns } from "./MySpace.vue?vue&type=template&id=23836164&scoped=true"
import script from "./MySpace.vue?vue&type=script&lang=js"
export * from "./MySpace.vue?vue&type=script&lang=js"
import style0 from "./MySpace.vue?vue&type=style&index=0&id=23836164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23836164",
  null
  
)

export default component.exports